import { useCallback, } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Description from '../UI/Description.jsx';
import Remerciement from '../UI/Remerciement.jsx';
import Consent from '../UI/Consent.jsx';
import DonneesPersonnelles from '../UI/DonneesPersonnelles.jsx';
import AudioRecorder from '../UI/AudioRecorder.jsx';
import { ManageCompteur } from '../Services/ManageCompteur.jsx';
import Compteur from '../UI/Compteur.jsx';
import TextParticipation from '../UI/TextParticipation.jsx';
import VideoImageAccueil from '../UI/BFM/VideoImageAccueil.jsx';
import Accueil from '../UI/Accueil.jsx';
import Titre from '../UI/Titre.jsx';

function VID508400({
    interaction,
    afficherAccueil,
    afficherEtapeCollecteParticipation,
    afficherEtapeRemerciement,
    afficherEtapeGRPD,
    afficherEtapeCollectInformationsPersonnelles,
    changerAfficherEtapeCollecteParticipation,
    changerEtapeRemerciement,
    changerEtapeCollecteParticipationVideo,
    changerEtapeCollecteParticipationImage,
    setConsent,
    consentGDPR,
    consentImage,
    passerEtapeRGPDEnabled,
    setField,
    saveDonneePersonnelle,
    setMessageErreur,
    userInformation,
    retourAccueil,
    handleRememberMeChange,
    rememberMe,
    canDonneesPersonnelleContinue,
    donneesPersonnelleValid,
    participation,
    changerAfficherEtapeCollecteParticipationTexte,
    changerAfficherEtapeCollecteParticipationVoix,
    changerAfficherEtapeCollecteParticipationImage,
    afficherEtapeCollecteParticipationTexte,
    afficherEtapeCollecteParticipationVoix,
    audioBlob,
    setAudioBlob,
    audioURL,
    setAudioURL,
    sendingParticipationState,
    changerEtapeCollecteParticipationVocale,
    changerEtapeCollecteParticipationTexte,
    afficherEtapeCollecteParticipationImage,
}) {
    const {
        counter,
        startCountdownTimer,
        stopCountdownTimer,
        afficherCompteur,
        setAfficherCompteur,
    } = ManageCompteur(interaction);

    const handleStartRecording = useCallback(
        (status) => {
            if (status === 'start') {
                startCountdownTimer();
            }
            if (status === 'stop') {
                stopCountdownTimer();
                setAfficherCompteur(true);
            }
        },
        [setAfficherCompteur, startCountdownTimer, stopCountdownTimer]
    );

    const handleAfficherCompteur = useCallback(
        () => {
            setAfficherCompteur(true);
        }, [setAfficherCompteur]
    );


    return (
        <>
        <Titre interaction={interaction} />
            {afficherAccueil && changerAfficherEtapeCollecteParticipation()}
            {afficherEtapeCollecteParticipationVoix &&
                <>
                    <div class="fond-gris-widget">
                        <Row className="text-center">
                            <Col>
                                <AudioRecorder
                                    audioURL={audioURL}
                                    setAudioURL={setAudioURL}
                                    audioBlob={audioBlob}
                                    sendingParticipationState={sendingParticipationState}
                                    setMessageErreur={setMessageErreur}
                                    setAudioBlob={setAudioBlob}
                                    maxRecordingTime={interaction.max_recording_time}
                                    onStartRecording={handleStartRecording}
                                    changerEtapeCollecteParticipationVocale={changerEtapeCollecteParticipationVocale}
                                    setAfficherEtapeCollecteParticipationImage={null}
                                    onRestartRecording={handleAfficherCompteur}
                                />
                            </Col>
                        </Row>
                        {afficherCompteur && audioURL === '' &&
                            <>
                                <Row>
                                    <Col>
                                        <Compteur counter={counter} />
                                    </Col>
                                </Row>
                            </>
                        }
                    </div>

                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
            }
            {
                afficherEtapeCollecteParticipationTexte &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>
                    <div class="fond-gris-widget">
                        <Row className="custom-collecte-participation">
                            <Col>
                                <TextParticipation
                                    participation={participation}
                                    sendingParticipationState={sendingParticipationState}
                                    changerEtapeCollecteParticipationTexte={changerEtapeCollecteParticipationTexte}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
            }
            {
                afficherEtapeCollecteParticipation &&
                // Page de collecte de participation (limité à 1 vote ou non)
                <>

                    <Row className="custom-collecte-participation">
                        <Col>
                            <VideoImageAccueil
                                participation={participation}
                                changerEtapeCollecteParticipation={changerEtapeCollecteParticipationVideo}
                                interaction={interaction}
                                textBTNParticiper='Participer en vidéo'
                                changerAfficherEtapeCollecteParticipationTexte={changerAfficherEtapeCollecteParticipationTexte}
                                changerAfficherEtapeCollecteParticipationVoix={changerAfficherEtapeCollecteParticipationVoix}
                                changerAfficherEtapeCollecteParticipationImage={changerAfficherEtapeCollecteParticipationImage}
                                retourAccueil={retourAccueil}
                                showImageParticipation={false}
                                isImageBlur={false}
                                dispositionBoutons={'vertical'}
                                showDescription={true}
                            />
                        </Col>
                    </Row>

                </>
            }
            {
                afficherEtapeCollectInformationsPersonnelles &&
                <>
                    <div class="fond-gris-widget">
                        <DonneesPersonnelles
                            interaction={interaction}
                            setField={setField}
                            userInformation={userInformation}
                            donneesPersonnelleValid={donneesPersonnelleValid}
                            handleRememberMeChange={handleRememberMeChange}
                            rememberMe={rememberMe}
                            canDonneesPersonnelleContinue={canDonneesPersonnelleContinue}
                            saveDonneePersonnelle={saveDonneePersonnelle}
                        />
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de collecte de données personnelles
            }
            {
                afficherEtapeGRPD &&
                <>
                    <div class="fond-gris-widget">
                        <Consent
                            customisation={interaction.segment_customisation}
                            consentGDPR={consentGDPR}
                            consentImage={consentImage}
                            setConsent={setConsent}
                        />
                        <Row className="custom-commandes">
                            <Col>
                                <Button onClick={changerEtapeRemerciement} disabled={!passerEtapeRGPDEnabled}>Continuer</Button>
                            </Col>
                        </Row>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de consentement
            }
            {
                afficherEtapeRemerciement &&
                <>
                    <div class="fond-gris-widget">
                        <Row className="custom-commandes">
                            <Col>
                                <Remerciement interaction={interaction} >Continuer</Remerciement>
                            </Col>
                        </Row>
                    </div>
                    <Row className="text-center">
                        <Col>
                            <Button onClick={retourAccueil} className="custom-btn-retour">Retour</Button>
                        </Col>
                    </Row>
                </>
                // Page de remerciemeent
            }

        </>
    )
}
export default VID508400;
